<script>
  import { Drawer } from 'element-ui'
  export default {
    name:'ElDrawer',
    extends:Drawer
  }
</script>
